import "./app.scss";
import App from "./app.svelte";

import * as Sentry from "@sentry/svelte";

let production = true;
if (import.meta.env.VITE_DEV == "true") {
  production = false;
}

if (production) {
    Sentry.init({
        dsn: "https://f75852a84be4c5932f2ced58c54d3b25@o4508647341686784.ingest.de.sentry.io/4508647345225808",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // VS-1213 - USE SENTRY'S SERVER SIDE DATA SCRUBBING INSTEAD
        // Currently removing user data doesn't work.
        // This is kept here for future reference.
        // beforeSend(event) {
        //     Sentry.setUser(null);
        //     // Remove user IP address
        //     delete event.user;
        //     // Remove request data that might contain user information
        //     if (event.request) {
        //         delete event.request.headers;
        //     }
        //     return event;
        // },
        sendClientReports: false,
        enableTracing: false,
        environment: `${production ? "production" : "development"}`,
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/visitory\.io\/(?:en|fi|sv|nb)\/dashboard\/api\//],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

// Initalizing the app component
const app = new App({
  target:
    document.getElementById("app") ||
    (() => {
      throw new Error('App container element `<div id="app"></div>` not found');
    })(),
});

export default app;
